"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameHome = void 0;
var vue_1 = require("vue");
var Button_1 = require("../components/common/Button");
var utils_1 = require("../utils/utils");
var GameSetupDetail_1 = require("../components/GameSetupDetail");
function copyToClipboard(text) {
    var input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
}
var DEFAULT_COPIED_PLAYER_ID = '-1';
exports.GameHome = vue_1.default.component('game-home', {
    props: {
        game: {
            type: Object,
        },
    },
    components: {
        Button: Button_1.Button,
        'game-setup-detail': GameSetupDetail_1.GameSetupDetail,
    },
    data: function () {
        return {
            urlCopiedPlayerId: DEFAULT_COPIED_PLAYER_ID,
        };
    },
    methods: {
        getGameId: function () {
            return this.game !== undefined ? this.game.id.toString() : 'n/a';
        },
        getTurnOrder: function (index) {
            if (index === 0) {
                return '1st';
            }
            else if (index === 1) {
                return '2nd';
            }
            else if (index === 2) {
                return '3rd';
            }
            else if (index > 2) {
                return index + 1 + "th";
            }
            else {
                return 'n/a';
            }
        },
        setCopiedIdToDefault: function () {
            this.urlCopiedPlayerId = DEFAULT_COPIED_PLAYER_ID;
        },
        getPlayerCubeColorClass: function (color) {
            return utils_1.playerColorClass(color.toLowerCase(), 'bg');
        },
        getHref: function (id) {
            if (id[0] === 's') {
                return "/spectator?id=" + id;
            }
            return "/player?id=" + id;
        },
        copyUrl: function (playerId) {
            copyToClipboard(window.location.origin + this.getHref(playerId));
            this.urlCopiedPlayerId = playerId;
        },
        isPlayerUrlCopied: function (playerId) {
            return playerId === this.urlCopiedPlayerId;
        },
        getSpectatorId: function () {
            var _a, _b;
            return (_b = (_a = this.game) === null || _a === void 0 ? void 0 : _a.spectatorId) !== null && _b !== void 0 ? _b : '';
        },
    },
    template: "\n      <div id=\"game-home\" class=\"game-home-container\">\n        <h1><span v-i18n>Terraforming mars</span> [game id: <span>{{getGameId()}}</span>]</h1>\n        <h4 v-i18n>Instructions: To start the game, share this page with all the players or separately copy and share the links with each player. Click on your name to start the game. <br> The first time someone clicks on a link, they will receive a password. From then on, only the player with the password can access that player page.</h4>\n        <ul>\n          <li v-for=\"(player, index) in (game === undefined ? [] : game.players)\">\n            <span class=\"turn-order\">{{getTurnOrder(index)}}</span>\n            <span :class=\"'color-square ' + getPlayerCubeColorClass(player.color)\"></span>\n            <span class=\"player-name\"><a :href=\"getHref(player.id)\">{{player.name}}</a></span>\n            <Button title=\"copy\" size=\"tiny\" :onClick=\"_=>copyUrl(player.id)\"/>\n            <span v-if=\"isPlayerUrlCopied(player.id)\" class=\"copied-notice\">Playable link for {{player.name}} copied to clipboard <span class=\"dismissed\" @click=\"setCopiedIdToDefault\" >dismiss</span></span>\n          </li>\n\n          <br>\n          <li v-if=\"game !== undefined && game.spectatorId !== undefined\">\n            <span class=\"player-name\"><a :href=\"getHref(getSpectatorId())\">Spectator</a></span>\n            <Button title=\"copy\" size=\"tiny\" :onClick=\"_=>copyUrl(getSpectatorId())\"/>\n            <span v-if=\"isPlayerUrlCopied(getSpectatorId())\" class=\"copied-notice\">Spectator link copied to clipboard <span class=\"dismissed\" @click=\"setCopiedIdToDefault\" >dismiss</span></span>\n          </li>\n        </ul>\n\n        <div class=\"spacing-setup\"></div>\n        <div v-if=\"game !== undefined\">\n          <h1 v-i18n>Game settings</h1>\n          <game-setup-detail :gameOptions=\"game.gameOptions\" :playerNumber=\"game.players.length\" :lastSoloGeneration=\"game.lastSoloGeneration\" :inlineDisplay=\"false\"></game-setup-detail>\n        </div>\n      </div>\n    ",
});
//# sourceMappingURL=GameHome.js.map